import React from 'react';
import { useTranslation } from "react-i18next";
import DOMPurify from "dompurify";
import './ClubDescription.css';

// Helper function to check if HTML content has meaningful text
const hasContent = (html) => {
  if (!html) return false;
  // Create a temporary div to parse HTML
  const temp = document.createElement('div');
  temp.innerHTML = html;
  // Get text content and trim whitespace
  const text = temp.textContent || temp.innerText;
  return text.trim().length > 0;
};

const ClubDescription = React.memo(({ description, localRules }) => {
  const { t } = useTranslation();

  const createMarkup = (html) => {
    return { __html: DOMPurify.sanitize(html) };
  };

  if (!hasContent(description) && !hasContent(localRules)) {
    return null;
  }

  return (
    <div className="clubInfo">
      {hasContent(description) && (
        <>
          <h1>{t("club_description_header")}</h1>
          <div className="ClubDescription">
            <div dangerouslySetInnerHTML={createMarkup(description)} />
          </div>
        </>
      )}
      
      {hasContent(localRules) && (
        <>
          <h1>{t("local_rules_header")}</h1>
          <div className="ClubRules">
            <div
              dangerouslySetInnerHTML={createMarkup(localRules)}
              style={{ overflow: "hidden" }}
            />
          </div>
        </>
      )}
    </div>
  );
});

ClubDescription.displayName = 'ClubDescription';

export default ClubDescription; 